import { createElement, useState } from "react";
import { useParams } from "react-router";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { deleteHttp } from "../../common/api/apiShared";
import { FrameworkCategoriesViewModel, FrameworkCategoryViewModel } from "./FrameworkCategories.types";
import { useTranslation } from "../../localization/useTranslation";
import { Trans } from "react-i18next";
import { useDotLegalQuery, useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useFrameworkCategories() {
    const snackbar = useDotLegalSnackbar();
    const { id } = useParams<{ id: string }>();
    const [showDialog, setShowDialog] = useState(false);
    const [showDeleteCategory, setShowDeleteCategory] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState<FrameworkCategoryViewModel>();

    const url = `/frameworks/${id}/categories`;
    const { isLoading, data, refetch } = useDotLegalQuery<FrameworkCategoriesViewModel>(url);

    const deleteMutation = useDotLegalMutation(deleteCategoryApi);
    const onDeleteClick = async () => {
        await deleteMutation.mutateAsync(selectedCategory!.id, {
            onSuccess: (response: any) => {
                const deleteResponse = response.value();
                if (deleteResponse.isDeleted) {
                    snackbar.show(createElement(Trans, { i18nKey: "frameworkCategoryDeleted", values: { name: selectedCategory?.name } }), "success");
                    setShowDeleteCategory(false);
                    setSelectedCategory(undefined);
                    refetch();
                } else {
                    snackbar.show(createElement(Trans, { i18nKey: "frameworkCategoryNotDeleted", values: { name: selectedCategory?.name } }), "warning");
                    setShowDeleteCategory(false);
                    setSelectedCategory(undefined);
                }
            },
        });
    };

    function onSelectCategory(id: string) {
        var category = data?.categories.find((x) => x.id === id);

        if (category) {
            setSelectedCategory(category);
        }
    }

    return {
        id,
        isLoading,
        data,
        showDialog,
        setShowDialog,
        selectedCategory,
        setSelectedCategory,
        showDeleteCategory,
        setShowDeleteCategory,
        refetch,
        onDeleteClick,
        onSelectCategory,
    };

    function deleteCategoryApi(categoryId: string) {
        return deleteHttp(`/frameworks/${id!}/categories/${categoryId}`);
    }
}
